import { ContainerModule } from '@evertel/di'
import { DocumentStore, DocumentACLStore, DocumentSchemaStore, DocumentSchemaRevisionStore } from './store/'
import { DocumentSearchController, DepartmentDocumentSchemasController, DocumentViewController, DepartmentSchemaCategoriesController, CategorySchemasController,
    DocumentACLsController, DocumentEditController, SchemaCategorySearchController, SchemaCategoryController,
    GlobalSchemaCategoriesController, CloneSchemaController, DocumentCreateController, DocumentSearchByRoomController } from './controller'
import { MediaUtils } from './utils'
import { DocumentStoreManager } from './DocumentStoreManager'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(DocumentStore).to(DocumentStore).inSingletonScope()
        m.bind(DocumentACLStore).to(DocumentACLStore).inSingletonScope()
        m.bind(DocumentSchemaStore).toSelf().inSingletonScope()
        m.bind(DocumentSchemaRevisionStore).toSelf().inSingletonScope()
        m.bind(DocumentStoreManager).toSelf().inSingletonScope()

        m.bind(DocumentSearchController).toSelf()
        m.bind(DepartmentDocumentSchemasController).toSelf()
        m.bind(DocumentViewController).toSelf()
        m.bind(DocumentACLsController).toSelf()
        m.bind(DocumentEditController).toSelf()
        m.bind(DocumentCreateController).toSelf()
        m.bind(SchemaCategorySearchController).toSelf()
        m.bind(SchemaCategoryController).toSelf()
        m.bind(DepartmentSchemaCategoriesController).toSelf()
        m.bind(CategorySchemasController).toSelf()
        m.bind(GlobalSchemaCategoriesController).toSelf()
        m.bind(CloneSchemaController).toSelf()
        m.bind(DocumentSearchByRoomController).toSelf()

        m.bind(MediaUtils).toSelf()
    })
]

export { DI_MODULES }
